// General
import React, { Component } from 'react';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../locale/messages';
import { Button, Modal } from 'react-bootstrap';
// Redux
import { connect } from 'react-redux';
import { closeDateFilterModal } from '../../../actions/siteadmin/modalActions';
import DateRange from '../PayoutManagement/DateRange/DateRange';

import { formValueSelector, change, reduxForm } from 'redux-form';


import bt from '../../../components/commonStyle.css';
import s from './DateFilterModal.css';

class DateFilterModal extends Component {

  constructor(props) {
    super(props)
    this.state = {
      smallDevice: false
    }
  }

  handleDateFilter = async () => {
    const { closeDateFilterModal, weeklyPayoutData: { refetch }, dates } = this.props;
    let variables = {
      currentPage: 1,
      dates
    }
    refetch(variables)
    closeDateFilterModal()
  };

  handleClear = () => {
    const { change, weeklyPayoutData: { refetch }, closeDateFilterModal } = this.props;
    let variables = {
      currentPage: 1,
      dates: null
    }
    change('dates', null)
    change('startDate', null)
    change('endDate', null)
    refetch(variables);
    closeDateFilterModal()
  };
  componentDidMount() {
    let isBrowser = typeof window !== "undefined";

    if (isBrowser) {
      this.handleResize();
      window.addEventListener("resize", this.handleResize);
    }
  }

  componentWillUnmount() {
    let isBrowser = typeof window !== "undefined";

    if (isBrowser) {
      window.removeEventListener("resize", this.handleResize);
    }
  }

  handleResize = (e) => {
    const isBrowser = typeof window !== "undefined";

    const smallDevice = isBrowser ? window.matchMedia("(max-width: 767px)").matches : false;

    this.setState({ smallDevice });
  };

  render() {
    const { closeDateFilterModal, dateFilterModal, dates, startDate, endDate } = this.props;
    const { formatMessage } = this.props.intl;
    const { smallDevice } = this.state;

    return (
      <Modal show={dateFilterModal} onHide={closeDateFilterModal} className={cx('wooberlyModal', 'wooberlyModalWidth')}>
        <Modal.Header closeButton>
          <Modal.Title>  <FormattedMessage {...messages['filterByDateLabel']} /></Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <div className='managePayoutDateWrapper'>
            <DateRange dates={dates} startDate={startDate} endDate={endDate} numberOfMonths={smallDevice ? 1 : 2} />
          </div>
          <div className='doubleButtonContainer'>
            <Button onClick={() => this.handleClear()} className={cx(bt.btnSecondary)} type="submit">
              {formatMessage(messages.clear)}
            </Button>
            <Button onClick={() => this.handleDateFilter()} className={cx(bt.btnPrimary)} type="submit">
              {formatMessage(messages.submitButton)}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}
DateFilterModal = reduxForm({
  form: "PayoutManagement", // a unique name for this form
  // destroyOnUnmount: false
})(DateFilterModal);

const selector = formValueSelector('PayoutManagement');

const mapState = (state) => ({
  dateFilterModal: state.adminModalStatus.dateFilterModal,
  dates: selector(state, 'dates'),
  startDate: selector(state, 'startDate'),
  endDate: selector(state, 'endDate'),
});
const mapDispatch = {
  closeDateFilterModal
};
export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(DateFilterModal)));

